type Iteratee<T> = ((item: T) => PropertyKey) | keyof T;

/**
 * Native replacement for lodash/fp `keyBy`. Builds an object keyed by the result
 * of `iteratee` (a function or a property key). When keys collide, the last
 * item wins (matching lodash).
 */
export default function keyBy<T>(
    collection: readonly T[] | null | undefined,
    iteratee: Iteratee<T>,
): Record<string, T> {
    return (collection ?? []).reduce<Record<string, T>>((result, item) => {
        const key = String(typeof iteratee === 'function' ? iteratee(item) : item[iteratee]);
        result[key] = item;
        return result;
    }, {});
}
